





















import Vue from 'vue';
import Component from 'vue-class-component';
import {AlertMessage, SurveyResource} from '@/interfaces';
import {Prop} from 'vue-property-decorator';
import {surveyFieldModule, surveyModule} from '@/store/modules';
import DialogAlert from '@/components/ui/DialogAlert.vue';
import DialogActions from '@/components/ui/DialogActions.vue';
import Dialog from '@/components/ui/Dialog.vue';
import {Route} from '@/enums';
import {surveyFieldItemModule} from '@/store/modules/surveyFieldItemModule';

@Component({
  components: {
    Dialog,
    DialogActions,
    DialogAlert,
  },
})
export default class SaveTemplateDialog extends Vue {
  @Prop() survey!: SurveyResource;
  private alert: AlertMessage | null = null;

  get busy(): boolean {
    return surveyModule.busy;
  }

  get saving(): boolean {
    return surveyModule.saving;
  }

  async cancel() {
    this.$emit('close');
  }
  async save(): Promise<void> {
    try {
      const survey = await surveyModule.action({
        attributes: {
          action: 'save-as-template',
          surveyId: this.survey.id,
        },
      });
      console.log(survey);
      this.alert = {
        type: 'success',
        message: 'Survey template saved successfully',
      };
      this.$emit('close', 'Survey template saved successfully');
      surveyModule.reset();
      surveyFieldModule.reset();
      surveyFieldItemModule.reset();
      await this.$router.push({
        name: Route.SurveysEdit,
        params: {id: survey.id},
      });
    } catch (err) {
      console.error(err);
      const error = err.response?.data?.errors[0]?.detail;
      this.alert = {type: 'error', message: error ? error : 'Error'};
    }
  }
}
